import { useEffect, useState } from 'react';

import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { Request, UseResource } from '../../utils/types';

export type RequestInput = NonNullable<TrpcInputs['updateRequest']>;
export type RequestOutput = TrpcOutputs['updateRequest'];

export type GetRequestOutput = TrpcOutputs['getRequest'];

type UseRequest = UseResource<Request, RequestInput, RequestOutput>;

export const useRequest = (id: number, initialRequest?: Partial<Request>): UseRequest => {
  const getRequest = trpc.getRequest.useQuery({ id }, { refetchOnWindowFocus: false });
  const updateRequest = trpc.updateRequest.useMutation();

  const [error, setError] = useState<string>();
  const [data, setData] = useState<Partial<RequestOutput>>(initialRequest);

  useEffect(() => {
    if (getRequest?.data) setData(getRequest?.data);
  }, [getRequest.data]);

  useEffect(() => {
    const errors: string[] = [];
    if (getRequest.error) errors.push(getRequest.error?.message);
    if (updateRequest.error) errors.push(updateRequest.error?.message);

    if (errors?.length > 0) setError(errors.join(', '));
  }, [getRequest.error, updateRequest.error]);

  trpc.onRequestUpdated.useSubscription(
    { id },
    {
      onData: (newData) => {
        setData(newData.request);
      },
      onError: (err: any) => {
        setError(err?.message);
      },
    },
  );

  const isLoading = getRequest?.isLoading || updateRequest?.isLoading;
  return {
    data,
    isLoading,
    error,
    mutate: (args) => updateRequest.mutateAsync({ id, ...args } as any),
  };
};
